// extracted by mini-css-extract-plugin
export var closeButton = "_lo-1";
export var closeX = "_lo-3";
export var container = "_lo-0";
export var image = "_lo-2";